module.exports = __webpack_public_path__ + "static/img/MR.cdce92d0.svg";